export default __webpack_public_path__ + "static/media/add-purple.202b3e6b.svg";